import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac87143"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-3" }
const _hoisted_3 = {
  method: "POST",
  action: "/",
  class: "my-1"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"2rem","font-weight":"700","letter-spacing":"0.1rem"} }, " Cash Account Agreement ")
  ])
], -1))
const _hoisted_7 = {
  class: "login-card bg-white p-4",
  style: {"border-radius":"6px"}
}
const _hoisted_8 = { class: "login-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group mt-1 mb-0 col-md-6" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "How many Cash Account required ? ")
], -1))
const _hoisted_11 = { class: "form-group col-md-6" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "form-group col-md-6" }
const _hoisted_18 = ["disabled", "onUpdate:modelValue", "id", "name"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "selected",
  value: ""
}, "Select Currency", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Authorised persons:"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#7f888f"} }, "Persons Authorised to give Instructions. Changes to this need to be received in writing before they take effect:")
], -1))
const _hoisted_23 = { class: "form-group col-md-3" }
const _hoisted_24 = ["onUpdate:modelValue", "id", "name"]
const _hoisted_25 = { class: "form-group col-md-3" }
const _hoisted_26 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_27 = { class: "form-group col-md-3" }
const _hoisted_28 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_29 = { class: "form-group col-md-3" }
const _hoisted_30 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_31 = {
  key: 1,
  class: "row"
}
const _hoisted_32 = { class: "form-group col-md-3" }
const _hoisted_33 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_34 = { class: "form-group col-md-3" }
const _hoisted_35 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_36 = { class: "form-group col-md-3" }
const _hoisted_37 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_38 = { class: "form-group col-md-3" }
const _hoisted_39 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_40 = {
  key: 2,
  class: "row"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Authorised persons:"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#7f888f"} }, "Persons Authorised to give Instructions. Changes to this need to be received in writing before they take effect:")
], -1))
const _hoisted_42 = ["disabled", "id", "value"]
const _hoisted_43 = ["for"]
const _hoisted_44 = {
  class: "login-card bg-white p-4 mt-3",
  style: {"border-radius":"6px"}
}
const _hoisted_45 = { class: "login-body" }
const _hoisted_46 = { class: "form-group mt-1 mb-0" }
const _hoisted_47 = { class: "label float-right" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "form-group col-md-6" }
const _hoisted_51 = { class: "form-group col-md-6" }
const _hoisted_52 = { class: "form-group col-md-6" }
const _hoisted_53 = { class: "form-group col-md-6" }
const _hoisted_54 = { class: "form-group mt-1 mb-0" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "icheck",
  type: "checkbox",
  class: "form-control",
  name: "icheck",
  required: ""
}, null, -1))
const _hoisted_56 = {
  style: {"height":"15px","width":"15px","margin":"5px"},
  width: "100mm",
  height: "100mm",
  version: "1.1",
  viewBox: "0 0 100 100"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m139.21 139.21h473.58v473.58h-473.58z",
      "inkscape:connector-curvature": "0"
    })
  ])
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(0,-197)",
  "inkscape:groupmode": "layer",
  "inkscape:label": "Layer 1"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(1.6371 0 0 1.6371 16.358 -155.86)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m-8.417 217.52h57.655v57.655h-57.655z",
      fill: "none",
      stroke: "#000",
      "stroke-miterlimit": "10",
      "stroke-width": "1.6707",
      "inkscape:connector-curvature": "0"
    }),
    /*#__PURE__*/_createElementVNode("g", {
      transform: "matrix(.35278 0 0 .35278 -152.74 113.7)",
      "clip-path": "url(#a)"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        transform: "matrix(4.7358,0,0,4.7358,139.21,139.21)",
        d: "m64.04 52.74 6.31 6.9806 13.98-20.311",
        fill: "none",
        stroke: "#000",
        "stroke-linecap": "square",
        "stroke-miterlimit": "10",
        "stroke-width": "5",
        "inkscape:connector-curvature": "0"
      })
    ])
  ])
], -1))
const _hoisted_59 = {
  style: {"height":"15px","width":"15px","margin":"5px"},
  width: "100mm",
  height: "100mm",
  viewBox: "0 0 100 100"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "m139.21 139.21h473.58v473.58h-473.58z",
      "inkscape:connector-curvature": "0"
    })
  ])
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  transform: "translate(0,-197)",
  "inkscape:groupmode": "layer",
  "inkscape:label": "Layer 1"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m2.5789 200.25h94.389v94.389h-94.389z",
    fill: "none",
    stroke: "#000",
    "stroke-miterlimit": "10",
    "stroke-width": "2.7351",
    "inkscape:connector-curvature": "0"
  })
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "I confirm that I have received, agreed and knowledge the following documents.", -1))
const _hoisted_63 = { style: {"font-size":"13px"} }
const _hoisted_64 = { class: "errorMsg danger ml-2" }
const _hoisted_65 = { class: "row justify-content-center mx-md-0 mx-1 mb-1 mt-0" }
const _hoisted_66 = { class: "col-md-12 col-12 px-1" }
const _hoisted_67 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_68 = { class: "modal-dialog" }
const _hoisted_69 = { class: "modal-content" }
const _hoisted_70 = { class: "modal-header" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Please fix this", -1))
const _hoisted_72 = { class: "modal-body" }
const _hoisted_73 = {
  key: 0,
  ref: "errorBlock",
  id: "errorBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_sodipodi58namedview = _resolveComponent("sodipodi:namedview")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        disabled: _ctx.is_director==1,
                        onInput: _cache[0] || (_cache[0] = ($event: any) => {_ctx.removeTagErr($event);_ctx.updateACurrency()}),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        type: "number",
                        class: "form-control font-size-15-18 text-center selected-field",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.no_of_cash_ac) = $event)),
                        name: "no_of_cash_ac",
                        id: "no_of_cash_ac",
                        required: ""
                      }, null, 40, _hoisted_12), [
                        [_vModelText, _ctx.no_of_cash_ac]
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.no_of_cash_ac), (index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("h4", _hoisted_16, "Cash Account : " + _toDisplayString(index), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("select", {
                            disabled: _ctx.is_director==1,
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeTagErr($event))),
                            "onUpdate:modelValue": ($event: any) => ((_ctx.account_currency[index-1]) = $event),
                            class: "form-control",
                            id: 'account_currency_'+index,
                            name: 'account_currency_'+index
                          }, [
                            _hoisted_19,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries.filter(info => info.currency !== ''), (c, I) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: I,
                                value: c.currency
                              }, _toDisplayString(c.currency) + " - " + _toDisplayString(c.name), 9, _hoisted_20))
                            }), 128))
                          ], 40, _hoisted_18), [
                            [_vModelSelect, _ctx.account_currency[index-1]]
                          ])
                        ])
                      ]),
                      (_ctx.is_corporate==0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Full Name and Official Position ",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.name_of_persons_1[index-1]) = $event),
                                id: 'name_of_persons_1_'+index,
                                name: 'name_of_persons_1_'+index,
                                required: ""
                              }, null, 40, _hoisted_24), [
                                [_vModelText, _ctx.name_of_persons_1[index-1]]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Authority (Signture Required)",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.authority_of_persons_1[index-1]) = $event),
                                name: 'authority_of_persons_1_'+index,
                                id: 'authority_of_persons_1_'+index,
                                required: ""
                              }, null, 40, _hoisted_26), [
                                [_vModelText, _ctx.authority_of_persons_1[index-1]]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Phone Number",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.phone_of_persons_1[index-1]) = $event),
                                name: 'phone_of_persons_1_'+index,
                                id: 'phone_of_persons_1_'+index,
                                required: ""
                              }, null, 40, _hoisted_28), [
                                [_vModelText, _ctx.phone_of_persons_1[index-1]]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Email Address",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.email_of_persons_1[index-1]) = $event),
                                name: 'email_of_persons_1_'+index,
                                id: 'email_of_persons_1_'+index,
                                required: ""
                              }, null, 40, _hoisted_30), [
                                [_vModelText, _ctx.email_of_persons_1[index-1]]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.is_corporate==0 || _ctx.corp_directors.length==0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Full Name and Official Position ",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.name_of_persons_2[index-1]) = $event),
                                name: 'name_of_persons_2_'+index,
                                id: 'name_of_persons_2_'+index
                              }, null, 40, _hoisted_33), [
                                [_vModelText, _ctx.name_of_persons_2[index-1]]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Authority: Signature Required?",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.authority_of_persons_2[index-1]) = $event),
                                name: 'authority_of_persons_2_'+index,
                                id: 'authority_of_persons_2_'+index
                              }, null, 40, _hoisted_35), [
                                [_vModelText, _ctx.authority_of_persons_2[index-1]]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Phone Number",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.phone_of_persons_2[index-1]) = $event),
                                name: 'phone_of_persons_2_'+index,
                                id: 'phone_of_persons_2_'+index
                              }, null, 40, _hoisted_37), [
                                [_vModelText, _ctx.phone_of_persons_2[index-1]]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removeTagErr($event))),
                                onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                                autocomplete: "off",
                                type: "text",
                                placeholder: "Email Address",
                                class: "form-control selected-field",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.email_of_persons_2[index-1]) = $event),
                                name: 'email_of_persons_2_'+index,
                                id: 'email_of_persons_2_'+index
                              }, null, 40, _hoisted_39), [
                                [_vModelText, _ctx.email_of_persons_2[index-1]]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.is_corporate==1 && _ctx.corp_directors.length>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _hoisted_41,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corp_directors, (director) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-group col-md-12",
                                key: director.director_id
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  disabled: _ctx.is_director==1,
                                  id: (director.director_id)+'_'+(index-1),
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.director_input) = $event)),
                                  value: (director.director_id)+'_'+(index-1),
                                  class: "normalCheckbox",
                                  type: "checkbox",
                                  name: "director_input"
                                }, null, 8, _hoisted_42), [
                                  [_vModelCheckbox, _ctx.director_input]
                                ]),
                                _createElementVNode("label", {
                                  for: (director.director_id)+'_'+(index-1),
                                  class: "normalLabel"
                                }, _toDisplayString(director.director_name) + " (" + _toDisplayString(director.director_email) + ")", 9, _hoisted_43)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("h5", null, [
                      _createTextVNode("E-Signature"),
                      _createElementVNode("label", _hoisted_47, "Date : " + _toDisplayString(_ctx.current_date), 1)
                    ]),
                    _hoisted_48
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeTagErr($event))),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        type: "text",
                        placeholder: "Your Name",
                        class: "form-control selected-field",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.e_name) = $event)),
                        name: "e_name",
                        id: "e_name",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.removeTagErr($event))),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        type: "text",
                        placeholder: "Your Email Address",
                        class: "form-control selected-field",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.e_email) = $event)),
                        name: "e_email",
                        id: "e_email",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_email]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[16] || (_cache[16] = ($event: any) => {_ctx.checkPhone($event);}),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        type: "text",
                        placeholder: "Your Phone Number",
                        class: "form-control selected-field",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.e_phone_no) = $event)),
                        name: "e_phone_no",
                        id: "e_phone_no",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_phone_no]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.removeTagErr($event))),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.e_dob) = $event)),
                        type: "date",
                        placeholder: "Your Email Address",
                        class: "form-control selected-field",
                        name: "e_dob",
                        id: "e_dob",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_dob]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    (this.confirm==1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "p-cursor",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.confirm=0;_ctx.confirm_error=''})
                        }, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_56, [
                            _hoisted_57,
                            _createVNode(_component_sodipodi58namedview, {
                              id: "base",
                              bordercolor: "#666666",
                              borderopacity: "1.0",
                              "inkscape:current-layer": "layer1",
                              "inkscape:cx": "164.85456",
                              "inkscape:cy": "262.3356",
                              "inkscape:document-units": "mm",
                              "inkscape:pageopacity": "0.0",
                              "inkscape:pageshadow": "2",
                              "inkscape:window-height": "667",
                              "inkscape:window-maximized": "1",
                              "inkscape:window-width": "1366",
                              "inkscape:window-x": "0",
                              "inkscape:window-y": "27",
                              "inkscape:zoom": "0.35",
                              pagecolor: "#ffffff",
                              showgrid: "false"
                            }),
                            _hoisted_58
                          ]))
                        ]))
                      : _createCommentVNode("", true),
                    (this.confirm==0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "p-cursor",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.confirm=1;_ctx.confirm_error=''})
                        }, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_59, [
                            _hoisted_60,
                            _createVNode(_component_sodipodi58namedview, {
                              id: "base",
                              bordercolor: "#666666",
                              borderopacity: "1.0",
                              "inkscape:current-layer": "layer1",
                              "inkscape:cx": "164.85456",
                              "inkscape:cy": "262.3356",
                              "inkscape:document-units": "mm",
                              "inkscape:pageopacity": "0.0",
                              "inkscape:pageshadow": "2",
                              "inkscape:window-height": "667",
                              "inkscape:window-maximized": "1",
                              "inkscape:window-width": "1366",
                              "inkscape:window-x": "0",
                              "inkscape:window-y": "27",
                              "inkscape:zoom": "0.35",
                              pagecolor: "#ffffff",
                              showgrid: "false"
                            }),
                            _hoisted_61
                          ]))
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_62,
                    _createElementVNode("ol", _hoisted_63, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approval_doc_list, (doc) => {
                        return (_openBlock(), _createElementBlock("li", { key: doc }, _toDisplayString(doc), 1))
                      }), 128))
                    ]),
                    _createElementVNode("small", _hoisted_64, _toDisplayString(_ctx.confirm_error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("button", {
                      id: "subBtn",
                      type: "button",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                      class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                    }, " Submit Now ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.closeModal('exampleModal'))),
              class: "btn btn-secondary",
              "data-mdb-dismiss": "modal"
            }, " Close ")
          ]),
          _createElementVNode("div", _hoisted_72, [
            (_ctx.errors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "alert alert-danger"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ], 64))
}